module.exports = __webpack_public_path__ + "static/media/esports-page-grid-4.1447a4b5.jpg";